import CardCommon from '@op/components/CardCommon';
import {
  tableIcon,
  lineIcon,
  barIcon,
  vsIcon,
  pieIcon,
  stackLineIcon,
  SymbolType,
} from '@op/constants/chart';
import { Col, Row } from 'tea-component';
import React, { useMemo, useState } from 'react';
import useLanguage from '@op/hooks/useLanguage';
import ReviewsProgress from './ReviewsProgress';
import Ratings from './Ratings';
import {
  getDefaultReview,
  useGameStorePcConsole,
} from '@op/pages/gamestore/hooks/useGameStorePcConsole';
import MentionsLineBarCharts from './MentionsLineBarCharts';
import MentionsPieCharts from './MentionsPieCharts';
import usePcConsoleTimelineChart from '@op/pages/gamestore/hooks/usePcConsoleTimelineChart';
import './index.scss';
import MentionsTable from './MentionsTable';
import { useHistory } from 'umi';
import { goToCompetitorKeyMetrics } from '@op/utils/url';
import { arrayToSimpleObj, sortTimeListFunc } from '@op/utils';
import { formatDateFunc } from '@op/utils/time';
import { decimalFormatPercentage } from '@op/utils/value';
import moment from 'moment';
import DetailWrapper from '@op/pages/Detail/component/DetailWrapper';
import SteamChart from './SteamChart';

// function getTableColumns(chartType: SymbolType) {
//   const common: Array<any> = [
//     {
//       text: 'Positive',
//       key: 'select_recommend',
//       type: chartType,
//       color: '#69D19C',
//       valueKey: 'review',
//     },
//     {
//       text: 'Negative',
//       key: 'select_non_recommend',
//       type: chartType,
//       color: '#F17C86',
//       valueKey: 'review',
//     },
//   ];

//   if (chartType === 'bar' || chartType === 'table') {
//     common.unshift({
//       text: '30-Day Positive %',
//       key: 'recent_reviews',
//       type: 'line',
//       color: '#5086F3',
//       valueKey: 'score',
//       numFmt: ['0%'],
//       format: (value: number) => decimalFormatPercentage(value, '-', 0),
//     });
//   }

//   return common;
// }

export default function Steam({
  filter,
  wholeGameInfo,
  gameInfo,
  gameData,
  games,
  showRank,
}: {
  filter: any;
  wholeGameInfo: any;
  gameInfo: any;
  gameData: any;
  games: Array<any>;
  showRank: boolean;
}) {
  const { formatMessage } = useLanguage();
  // const [chartType, setChartType] = useState<SymbolType>('bar');
  // function changeChartType(type: any) {
  //   if (type === 'vs') {
  //     goToCompetitorKeyMetrics(history, filter, 'Game Store');
  //   } else {
  //     setChartType(type || 'bar');
  //   }
  // }

  const { trendTimeline, steamInfo, bottomGameStoreRenderList, loading } =
    useGameStorePcConsole({
      filter,
    });

  // const seriesDataKeys = useMemo(() => {
  //   return getTableColumns(chartType);
  // }, [chartType]);

  // const { chartMap, chartNoDataMap } = usePcConsoleTimelineChart({
  //   platformData: trendTimeline,
  //   filterParams: filter,
  //   seriesDataKeys,
  // });

  // const { emptyDescText, hasEmptyImg, hasEmptyTitle } = useMemo(() => {
  //   let emptyDescText = 'No Steam data under current filter selections';
  //   let hasEmptyImg = true;
  //   let hasEmptyTitle = true;
  //   const formatDate = (date: moment.MomentInput) => moment(date, 'YYYY-MM-DD');
  //   if (chartNoDataMap) {
  //     const { release_time: release } =
  //       gameData?.[filter?.edition_unified_id] || {};
  //     const valid =
  //       release &&
  //       formatDate(filter?.end_time).diff(formatDate(release), 'days') > 30;
  //     if (!valid) {
  //       emptyDescText =
  //         '“Recent Reviews” refer to reviews from the past 30 days. Therefore, data is only available starting from the 31st day after launch.';
  //       hasEmptyTitle = false;
  //       hasEmptyImg = false;
  //     }
  //   }

  //   return {
  //     emptyDescText,
  //     hasEmptyImg,
  //     hasEmptyTitle,
  //   };
  // }, [chartNoDataMap, filter, gameData]);

  const history = useHistory();

  // const records = useMemo(() => {
  //   const dateType = filter.date_type;
  //   const formatDate = formatDateFunc(dateType);
  //   const records: { [key in string]: any } = seriesDataKeys.reduce(
  //     (pre, { key, valueKey }) => {
  //       const selectedData = chartMap?.[key] || [];
  //       const value = arrayToSimpleObj(selectedData, valueKey, ({ time }) =>
  //         formatDate(time),
  //       );
  //       return { ...pre, [key]: value };
  //     },
  //     {},
  //   );

  //   const table: { [key in string]: any } = {};
  //   for (const key in records) {
  //     const element = records[key];
  //     Object.keys(element).forEach((time: string) => {
  //       if (!table[time]) table[time] = { time };

  //       table[time] = { ...table[time], [key]: element[time] };
  //     });
  //   }

  //   const list = Object.values(table);
  //   list.sort(sortTimeListFunc('time', 'desc'));

  //   return list;
  // }, [chartMap, seriesDataKeys]);

  const leftEmpty = useMemo(() => {
    if (!steamInfo.all_reviews && !steamInfo.recent_reviews) return true;
    return (
      steamInfo?.all_reviews?.review === 0 &&
      steamInfo?.recent_reviews?.review === 0
    );
  }, [steamInfo]);

  const specialHeight = useMemo(() => {
    return bottomGameStoreRenderList.length === 0 ? 85 : 0;
  }, [bottomGameStoreRenderList]);

  // function getChartElement(type: SymbolType, eventsDict?: any) {
  //   if (type === 'table') {
  //     return (
  //       <MentionsTable
  //         seriesDataKeys={seriesDataKeys}
  //         filter={filter}
  //         records={records}
  //         specialHeight={specialHeight}
  //         eventsDict={eventsDict}
  //       />
  //     );
  //   }

  //   if (type === 'pie') {
  //     return (
  //       <MentionsPieCharts
  //         data={steamInfo}
  //         filter={filter}
  //         specialHeight={specialHeight}
  //         eventsDict={eventsDict}
  //       ></MentionsPieCharts>
  //     );
  //   }

  //   return (
  //     <MentionsLineBarCharts
  //       chartMap={chartMap}
  //       filter={filter}
  //       seriesDataKeys={seriesDataKeys}
  //       chartType={chartType}
  //       pieData={steamInfo}
  //       specialHeight={specialHeight}
  //       eventsDict={eventsDict}
  //     ></MentionsLineBarCharts>
  //   );
  // }

  return (
    <CardCommon
      className="card-common-dbo-key-metrics-steam card-slot"
      contentCard
      title={
        <span style={{ fontSize: 20 }}>
          {formatMessage({ id: 'Game Store' })}
        </span>
      }
      hasTitleArrow
      handleTitleOnClick={() => {
        history.push('/opinion/SteamPerformance/SteamRatings');
      }}
    >
      <CardCommon
        className="card-common-dbo-key-metrics"
        title={<span>{formatMessage({ id: 'Game Store' })}</span>}
        hasTitleArrow
        handleTitleOnClick={() => {
          history.push('/opinion/SteamPerformance/SteamRatings');
        }}
        logBtnId="KMGS_PC"
        // empty={chartNoDataMap}
        // emptyHeight={378}
        loading={loading}
        loadingHeight={378}
      >
        <Row className="dbo-metrics-gamestore-box">
          <Col span={6}>
            <div className="dbo-metrics-gamestore-box-left">
              {/* 组件来源 home/page/studio/opinions/GameStore*/}
              <ReviewsProgress
                data={steamInfo.all_reviews || getDefaultReview()}
                title="All Reviews"
                rankTitle="All Reviews Positive%-1"
                games={games}
                gameData={gameData}
                filter={filter}
                by_type="all_reviews"
                rankLogId={'KMGS_PC_AllReviewsRanking'}
                showRank={showRank}
              ></ReviewsProgress>
              <ReviewsProgress
                data={steamInfo.recent_reviews || getDefaultReview()}
                title="Recent Reviews"
                games={games}
                gameData={gameData}
                rankTitle="Recent Reviews Positive%-1"
                filter={filter}
                by_type="recent_reviews"
                rankLogId={'KMGS_PC_RecentReviewsRanking'}
                showRank={showRank}
              ></ReviewsProgress>
            </div>
          </Col>
          <Col span={18}>
            <div className="dbo-metrics-gamestore-box-right">
              <div className="dbo-metrics-gamestore-ratings-box">
                <SteamChart filter={filter} gameData={gameData} specialHeight={specialHeight} steamInfo={steamInfo} trendTimeline={trendTimeline} detailPage />
                {/* 组件来源 home/page/studio/opinions/GameStore*/}
                {!(leftEmpty) && (
                  <Ratings renderList={bottomGameStoreRenderList} />
                )}
              </div>
            </div>
          </Col>
        </Row>
      </CardCommon>
    </CardCommon>
  );
}
